import React, { useState } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import { submitStaticForm } from '../../utils/formSubmit';
import { useLanguage } from '../../i18n/LanguageContext';

const ContactForm = () => {
  const { t } = useLanguage();
  const formEndpoint = 'https://formsubmit.co/Emmanuel-Merida@outlook.com';

  const [forms, setForms] = useState({
    name: '',
    company: '',
    email: '',
    subject: '',
    message: '',
  });
  const [validator] = useState(new SimpleReactValidator({ className: 'errorMessage' }));
  const [status, setStatus] = useState({ type: '', message: '' });
  const [, forceUpdate] = useState(0);

  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    setStatus({ type: '', message: '' });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (validator.allValid()) {
      validator.hideMessages();
      setStatus({ type: 'sending', message: t.form.sending });
      try {
        await submitStaticForm(e.currentTarget);
        setForms({ name: '', company: '', email: '', subject: '', message: '' });
        setStatus({ type: 'success', message: t.form.successMsg });
      } catch {
        setStatus({ type: 'error', message: t.form.errorMsg });
      }
    } else {
      validator.showMessages();
      forceUpdate((c) => c + 1);
      setStatus({ type: 'error', message: t.form.validationMsg });
    }
  };

  return (
    <form
      action={formEndpoint}
      method="POST"
      onSubmit={submitHandler}
      className="contact-validation-active"
    >
      <input type="hidden" name="_subject" value="New message from emmanuelmerida.com" />
      <input type="hidden" name="_template" value="table" />
      <input type="hidden" name="_captcha" value="false" />
      <div className="row">
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.name}
              type="text"
              name="name"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder={t.form.namePlaceholder}
            />
            {validator.message('name', forms.name, 'required|alpha_space')}
          </div>
        </div>
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.company}
              type="text"
              name="company"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder={t.form.companyPlaceholder}
            />
          </div>
        </div>
        <div className="col col-lg-12 col-12">
          <div className="form-field">
            <input
              value={forms.email}
              type="email"
              name="email"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder={t.form.emailPlaceholder}
            />
            {validator.message('email', forms.email, 'required|email')}
          </div>
        </div>
        <div className="col col-lg-12 col-12">
          <div className="form-field">
            <select
              onBlur={changeHandler}
              onChange={changeHandler}
              value={forms.subject}
              name="subject"
            >
              <option value="" disabled>{t.form.serviceDefault}</option>
              {(t.form?.serviceOptions ?? []).map((option, idx) => (
                <option key={idx}>{option}</option>
              ))}
            </select>
            {validator.message('subject', forms.subject, 'required')}
          </div>
        </div>
        <div className="col col-lg-12 col-12">
          <textarea
            onBlur={changeHandler}
            onChange={changeHandler}
            value={forms.message}
            name="message"
            placeholder={t.form.messagePlaceholder}
          />
          {validator.message('message', forms.message, 'required')}
        </div>
      </div>
      <div className="submit-area">
        <button type="submit" className="theme-btn" disabled={status.type === 'sending'}>
          {t.form.submitBtn}
        </button>
        {status.message && (
          <p className={status.type === 'error' ? 'errorMessage' : ''}>{status.message}</p>
        )}
      </div>
    </form>
  );
};

export default ContactForm;
